import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-admin-clinic-details',
  templateUrl: 'admin-clinic-details.html',
})
export class AdminClinicDetailsPage {

  clinic: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.clinic = this.navParams.get('clinic')
    console.log("Clinic: ", this.clinic)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminClinicDetailsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-clinic-details/admin-clinic-details.ts